const DEFAULT_BACKEND_ORIGIN = "https://app.firm.net.au";

export const getBackendOrigin = () => {
  const configured =
    process.env.REACT_APP_BACKEND_ORIGIN ||
    process.env.REACT_APP_API_ORIGIN ||
    DEFAULT_BACKEND_ORIGIN;

  return String(configured).replace(/\/$/, "");
};

export const isCapacitorNative = () => {
  if (typeof window === "undefined") return false;

  const protocol = window.location?.protocol || "";
  if (protocol && protocol !== "http:" && protocol !== "https:") {
    return true;
  }

  if (window.location?.origin === "null") {
    return true;
  }

  const capacitor = window.Capacitor;
  if (!capacitor) return false;

  if (typeof capacitor.isNativePlatform === "function") {
    return capacitor.isNativePlatform();
  }

  return Boolean(capacitor.platform && capacitor.platform !== "web");
};

export const shouldUseHostedBackend = () => (
  process.env.REACT_APP_FORCE_HOSTED_BACKEND === "true" || isCapacitorNative()
);

export const resolveBackendUrl = (path) => {
  const value = String(path || "");
  if (/^https?:\/\//i.test(value)) return value;
  if (!shouldUseHostedBackend()) return value;
  if (!value.startsWith("/")) return value;
  return `${getBackendOrigin()}${value}`;
};
